import { createReducer, on } from '@ngrx/store';
import { clearUser, getUser, getUserFail, getUserSuccess } from '@core/user/store/user.actions';
import { failStatus, initialStatus, loadingStatus, successStatus } from '@core/models/request-status.model';
import { ANONYMOUS_USER_NAME, Customer } from '@core/user/utilities/user.model';

const initialState: Customer = {
  firstName: ANONYMOUS_USER_NAME,
  isAuthenticated: false,
  ...initialStatus,
};

export const userReducer = createReducer(
  initialState,

  on(clearUser, (): Customer => {
    const response: Customer = {
      ...initialState,
    };

    return response;
  }),

  on(getUser, (state: Customer): Customer => {
    const response: Customer = {
      ...state,
      ...loadingStatus,
    };

    return response;
  }),

  on(getUserSuccess, (_state: Customer, data: any): Customer => {
    const response: Customer = {
      ...data.user,
      ...{ isAuthenticated: true },
      ...successStatus,
    };

    return response;
  }),

  on(getUserFail, (_state: Customer, data: any): Customer => {
    const response: Customer = {
      ...initialState,
      ...failStatus,
      message: data.message,
    };

    return response;
  }),
);
